import * as React from 'react';
import { DesignSection } from '@routes/event/create/DesignDemo/types';
import { BaseButton } from '@routes/event/create/components/BaseButton';

interface Props {
  className?: string;
  section: DesignSection;
  value: string;
  onClick: React.MouseEventHandler<HTMLElement>;
  ariaLabel: string;
}

export class BucketGroupOption extends React.PureComponent<Props> {
  render(): React.ReactNode {
    return (
      <BaseButton
        data-section={this.props.section}
        value={this.props.value}
        onClick={this.props.onClick}
        aria-label={this.props.ariaLabel}
        title={this.props.ariaLabel}
        className={this.props.className}
      >
        {this.props.children}
      </BaseButton>
    );
  }
}
